document.querySelector('body').classList.remove('no-js');
document.querySelector('body').classList.add('js');